import { from, of } from 'rxjs';
import { switchMap, catchError, map } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { dfimAxios } from '../config/Axios';
import {
  USER_CREATE,
  USER_MASS_CREATE,
  USER_EDIT,
  USER_DELETE,
  GET_USERS,
  getAllUsersSuccess,
  getAllUsersError,
  userCreateSuccess,
  userCreateError,
  userMassCreateSuccess,
  userMassCreateError,
  userEditSuccess,
  userEditError,
  userDeleteSuccess,
  userDeleteError,
} from '../actions/User';

const usersForAdminGetRequest = () =>
  dfimAxios.get('/api/user/all').then((response) => response.data);
const usersForSuperUserGetRequest = () =>
  dfimAxios.get('/api/user/all/company').then((response) => response.data);

const userCreateRequest = (input) =>
  dfimAxios
    .post('/api/user/create', input, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) => response.data);
const userMassCreateRequest = (input) =>
  dfimAxios
    .post('/api/user/create/mass', input, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) => response.data);
const userEditRequest = (input) =>
  dfimAxios
    .put('/api/user/edit', input, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) => response.data);
const userDeleteRequest = (input) =>
  dfimAxios
    .delete('/api/user/delete', {
      headers: {
        'Content-Type': 'application/json',
      },
      data: { id: input },
    })
    .then((response) => response.data);

export const userGetAllEpic = (action$) =>
  action$.pipe(
    ofType(GET_USERS),
    switchMap((action) =>
      from(
        action.payload.result.user.authority === 'ADMIN'
          ? usersForAdminGetRequest()
          : usersForSuperUserGetRequest()
      ).pipe(
        map((data) => getAllUsersSuccess(data)),
        catchError((error) => of(getAllUsersError(error)))
      )
    )
  );

export const userCreateEpic = (action$) =>
  action$.pipe(
    ofType(USER_CREATE),
    switchMap((action) =>
      from(userCreateRequest(action.payload)).pipe(
        map((data) => userCreateSuccess(data)),
        catchError((error) => of(userCreateError(error)))
      )
    )
  );

export const userMassCreateEpic = (action$) =>
  action$.pipe(
    ofType(USER_MASS_CREATE),
    switchMap((action) =>
      from(userMassCreateRequest(action.payload)).pipe(
        map((data) => userMassCreateSuccess(data)),
        catchError((error) => of(userMassCreateError(error)))
      )
    )
  );

export const userEditEpic = (action$) =>
  action$.pipe(
    ofType(USER_EDIT),
    switchMap((action) =>
      from(userEditRequest(action.payload)).pipe(
        map((data) => userEditSuccess(data)),
        catchError((error) => of(userEditError(error)))
      )
    )
  );

export const userDeleteEpic = (action$) =>
  action$.pipe(
    ofType(USER_DELETE),
    switchMap((action) =>
      from(userDeleteRequest(action.payload)).pipe(
        map((data) => userDeleteSuccess(data)),
        catchError((error) => of(userDeleteError(error)))
      )
    )
  );

// eslint-disable-next-line import/no-anonymous-default-export
export default [userCreateEpic, userMassCreateEpic, userEditEpic, userDeleteEpic, userGetAllEpic];
